import { GroupSchema, UserSchema } from "../generated/zod/schemas/models";
import { z } from "@hono/zod-openapi";

const groups = z
  .object({
    group: GroupSchema.pick({ id: true, name: true, type: true }),
  })
  .array();

export const ReadUserSchema = UserSchema.strip()
  .extend({
    groups,
  });

export const userEnvelopeSchema = z.object({
  user: ReadUserSchema,
});

// Use UserSchema and modify for updates
// Dates are already coerced by default, so no need to extend with coerce.date()
export const UpdateUserSchema = UserSchema.omit({
  id: true,
}).partial();

// Use UserSchema and modify for creates
export const CreateUserSchema = UserSchema.omit({
  id: true,
})
  .partial()
  .required({ firstName: true, lastName: true });

export const ListUsersSchema = UserSchema.strip()
  .extend({
    groups,
  })
  .array();

export const forgotPasswordSchema = z.object({
  email: z.email("Invalid email address"),
});